import { eventActions } from "@src/store";
import React, { MouseEvent } from "react";
import { ManageInventoryTabEnum } from "@src/store/pricing/selectionSlice";
import { useAppDispatch } from "@src/store/hooks";
import { Button, ButtonVariant } from "../button/Button";
import { MixpanelCategory, mixpanelTrack } from "../utils/mixPanelUtils";
import styles from "./EditInventory.module.scss";
import { requestAutopricerExit } from "@src/pages/home/children/pricing/components/manage-inventory/autopricerExitGuard";

export const EditInventory: React.FC<{
	itemId: number;
}> = ({ itemId }) => {
	const dispatch = useAppDispatch();

	const handleEditButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		requestAutopricerExit(() => {
			dispatch(
				eventActions.setInventory({
					inventoryItemIds: [itemId],
					isEditListingEnabled: true,
				}),
			);
			dispatch(eventActions.setManageInventoryTab(ManageInventoryTabEnum.ManageListing));
			mixpanelTrack(MixpanelCategory.EDIT_INVENTORY);
		});
	};

	return (
		<Button
			variant={ButtonVariant.Secondary}
			className={styles.main}
			controlSize="xsm"
			tabIndex={0}
			onClick={handleEditButtonClick}>
			<div>Edit</div>
		</Button>
	);
};
